export default __webpack_public_path__ + "static/media/screen-ecoleta.48be593e.png";